import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedUnit: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedUnit(state, payload) {
      state.selectedUnit = payload
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit('setListLoading', true);
      let list = await api.get('units');
      commit('setList', list.data);
      commit('setListLoading', false);
    },
    async loadByID({ commit }, id) {
      commit('setListLoading', true);
      let list = await api.get('units/byID', { params: { id: id } });
      commit('setSelectedUnit', list.data[0]);
      commit('setListLoading', false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("units", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`units`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedUnit(state) {
      return state.selectedUnit
    }
  }
}
